import { Component, Input } from '@angular/core';

@Component({
  selector: 'payment-payable-cutoff-time-text',
  templateUrl: './payable-cutoff-time-text.component.html',
  styleUrls: ['./payable-cutoff-time-text.component.scss'],
})
export class PayableCutoffTimeTextComponent {
  @Input() cutOffTime: string;
}
